import { z } from "zod";
const coordinate = z.number().finite().min(0).max(1);
const point = z.object({ x: coordinate, y: coordinate }).strict();
const rectangle = {
    height: z.number().finite().positive().max(1),
    width: z.number().finite().positive().max(1),
    x: coordinate,
    y: coordinate,
};
const fitsCanvas = (value) => value.x + value.width <= 1 && value.y + value.height <= 1;
/** Structured campus orientation geometry for authoring and v3 publications. */
export const interactiveCampusMapSchema = z.object({
    buildings: z.array(z.object({
        ...rectangle,
        buildingId: z.string().uuid(),
        shortName: z.string().trim().min(1).max(24),
    }).strict().refine(fitsCanvas, "Building must fit the campus canvas")).max(100),
    canvasHeight: z.number().int().min(100).max(16_384),
    canvasWidth: z.number().int().min(100).max(16_384),
    parking: z.array(z.object({
        ...rectangle,
        id: z.string().trim().min(1).max(80),
        name: z.string().trim().min(1).max(120),
    }).strict().refine(fitsCanvas, "Parking must fit the campus canvas")).max(100),
    schemaVersion: z.literal(1),
    sourceAttribution: z.string().trim().min(1).max(500),
    streets: z.array(z.object({
        from: point,
        label: point,
        labelRotation: z.number().finite().min(-180).max(180).default(0),
        name: z.string().trim().min(1).max(120),
        to: point,
    }).strict()).max(100),
}).strict().superRefine((value, context) => {
    if (new Set(value.buildings.map((building) => building.buildingId)).size !== value.buildings.length) {
        context.addIssue({ code: "custom", message: "Building references must be unique", path: ["buildings"] });
    }
    if (new Set(value.parking.map((parking) => parking.id)).size !== value.parking.length) {
        context.addIssue({ code: "custom", message: "Parking identifiers must be unique", path: ["parking"] });
    }
});
//# sourceMappingURL=campus.js.map